import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreenB } from '../../../store/actions/navigation.action'
import {Avatar, CardHeader, CircularProgress, Dialog, FormControlLabel, Radio, RadioGroup, TextField, AppBar, Toolbar, IconButton, Typography, Divider } from '@material-ui/core'
import { change, show, success, first, second, third, fourth, fifth, plus } from '../../../store/actions/campaigns.action'
import { FaEyeSlash, FaUser, FaLaugh, FaCheck, FaPiggyBank } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { IoLogoWhatsapp } from "react-icons/io"
import { changeScreen } from '../../../store/actions/navigation.action'
import MaskedInput from 'react-text-mask'
import Detail from '../transactions/detail'
import { domain, rootUrl } from '../../../config/App'
import Fullname from '../../components/Fullname'
import { redirectView } from '../../../store/actions/transaction.action'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function Raffle(props) {
    const dispatch = useDispatch()
    const { campaign, error } = useSelector(state => state.campaignsReducer)
    const id = (props.uid) ? props.uid : null;

    const [isLoading, setLoading] = React.useState(true)

    const [detail, setDetail] = React.useState({
        id: null,
        open: false,
        user_id: null
    })

    const [ state, setState ] = React.useState({
        telefone: false,
        telefone2: false,
        telefone3: false,
        telefone4: false,
        telefone5: false,
    })

    React.useEffect(() => {
        dispatch(show(id)).then(() => setLoading(false))

        return () => {
            dispatch(change('clear'))
            dispatch(success(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    const _detail = (id, user_id) => {
        setDetail({
            id: id,
            open: true,
            user_id: user_id
        })
    }

    const _handleRedirectView = (id, url) => {
        dispatch(redirectView(id, url))
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">{campaign.ganhador ? 'Resultado da Ação' : 'Sortear Ação'}</Typography>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail uid={detail.id} user_id={detail.user_id} onClose={() => setDetail({ id: null, open: false, user_id: null })}/>
            </Dialog>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    {!campaign.ganhador &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className={campaign.federal === 1 ? "mb-4" : ""}>
                                <label className="label-custom mb-3 bs-color-b">Tipo de Sorteio</label>
                                <RadioGroup
                                    row
                                    name="federal"
                                    value={campaign.federal}
                                    onChange={text => dispatch(change({ federal: parseInt(text.target.value) }))}
                                    className="fw-normal bs-color-b"
                                >
                                    <FormControlLabel value={1} control={<Radio color="primary" />} label="Loteria Federal" />
                                    <FormControlLabel value={0} control={<Radio color="primary" />} label="Livre" />
                                </RadioGroup>
                            </div>

                            {(campaign.federal === 1) &&
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="label-custom bs-color-b">N° do concurso</label>
                                        <TextField
                                            error={(error.concurso) && true}
                                            value={campaign.concurso || ''}
                                            placeholder="ex: 5576"
                                            type="tel"
                                            onChange={text => {
                                                dispatch(change({ concurso: text.target.value }))
                                                if (error.concurso && delete error.concurso);
                                            }}
                                        />

                                        {(error.concurso) &&
                                            <strong className="text-danger">{error.concurso[0]}</strong>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    <div className="card card-body mt-3 bs-bg">
                        <div className="row">
                            {(!campaign.ganhador) &&
                                <>
                                <div className="col-md-12">
                                    <label className="label-custom mb-4 bs-color-b">1° prêmio</label>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="label-custom bs-color-b">Resultado {campaign.federal === 1 && 'Loteria Federal'}</label>
                                        <TextField
                                            error={(error.resultado) && true}
                                            value={campaign.resultado || ''}
                                            placeholder="ex: 035154"
                                            type="tel"
                                            InputProps={{
                                                inputComponent: TextMaskCustom,
                                                onChange: text => {
                                                    dispatch(change({ resultado: text.target.value }))
                                                    if (error.resultado && delete error.resultado);
                                                }
                                            }}
                                        />

                                        {(error.resultado) &&
                                            <strong className="text-danger">{error.resultado[0]}</strong>
                                        }
                                    </div>
                                </div>
                                </>
                            }

                            {(campaign.ganhador) &&
                                <>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">1° prêmio</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar src={rootUrl + 'img/rifa/' + campaign.cover.img + '?w=100&h=100&s=' + campaign.id} />
                                    }
                                    title={<h6 className="fw-bold m-0 bs-color-b">{campaign.product}</h6>}
                                    subheader={
                                        <>
                                        {(campaign.federal === 1 && campaign.concurso) &&
                                            <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{campaign.concurso}</span></span>
                                        }
                                        </>
                                    } 
                                />
                                <CardHeader 
                                    avatar={
                                        <Avatar className="bg-success" sizes="large">
                                            <FaCheck />
                                        </Avatar>
                                    }
                                    title={<h3 className="fw-semibold m-0 bs-color-b">{campaign.extracao}</h3>}
                                    subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                />
                                
                                <hr className="hr-muted m-0"/>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaUser />
                                        </Avatar>
                                    }
                                    title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={campaign.ganhador.name} />}</h6>}
                                    subheader={
                                        <>
                                        <div className="d-flex justify-content-between">
                                            <div className="d-flex flex-column mb-2">
                                                <span className="d-block pointer bs-color" onClick={() => setState({ ...state, telefone: state.telefone ? false : true })}>
                                                    {(state.telefone) ? campaign.ganhador.telefone : <> {campaign.ganhador.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                </span>

                                                {campaign.ganhador_transaction?.location &&
                                                    <span className="bs-color">{campaign.ganhador_transaction?.location?.estado}</span>
                                                }
                                            </div>
                                            
                                            <span className="me-2">
                                                <a href={'http://wa.me/55'+campaign.ganhador.telefone} target="_blank" rel="noopener noreferrer">
                                                    <IoLogoWhatsapp color="#24d366" size={30}/>
                                                </a>
                                            </span>
                                        </div>

                                        <span onClick={() => handlePage('shopping', campaign.ganhador.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                        
                                        </>
                                    } 
                                />
                                    
                                {(domain !== 'glauciamendes.com' && domain !== 'alanrocha.com') &&
                                <>
                                <hr className="hr-muted m-0"/>
                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                <CardHeader
                                    avatar={
                                        <Avatar className="avatar-item pointer" onClick={() => _detail(campaign.ganhador_transaction.id, campaign.ganhador.id)}>
                                            <FaLaugh />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row pointer" onClick={() => _detail(campaign.ganhador_transaction.id, campaign.ganhador.id)}>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador_transaction.transaction_amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color pointer" onClick={() => _detail(campaign.ganhador_transaction.id, campaign.ganhador.id)}>Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(campaign.ganhador_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.ganhador_transaction.updated_at))}</span>
                                        {campaign.ganhador_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                        <span className="pointer fw-bold text-danger d-block mt-2" onClick={() => _handleRedirectView(campaign?.ganhador_transaction?.id, campaign?.url_amigavel) }>Ver Compra</span>
                                        </>
                                    }
                                />

                                {campaign.ganhador_transaction_total.shopping > 1 &&
                                <>
                                <hr className="hr-muted m-0"/>
                                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                <CardHeader
                                    className="pointer"
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaPiggyBank />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador_transaction_total.amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color">Compras: {campaign.ganhador_transaction_total.shopping}</span>
                                        </>
                                    }
                                />
                                </>
                                }
                                </>
                                }

                            </>
                            }
                        </div>
                        {(!campaign.ganhador) &&
                            <div className="d-flex mt-3">
                                <button onClick={() => dispatch(first(campaign))} type="button" className="btn btn-success rounded-0">
                                    Sortear
                                </button>
                            </div>
                        }
                    </div>

                    {(campaign.product2) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">
                                {(!campaign.ganhador2) &&
                                    <>
                                    <div className="col-md-12">
                                        <label className="label-custom mb-4 bs-color-b">2° prêmio</label>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="label-custom bs-color-b">Resultado {campaign.federal === 1 && 'Loteria Federal'}</label>
                                            <TextField
                                                error={(error.resultado2) && true}
                                                value={campaign.resultado2 || ''}
                                                placeholder="ex: 035154"
                                                type="tel"
                                                InputProps={{
                                                    inputComponent: TextMaskCustom,
                                                    onChange: text => {
                                                        dispatch(change({ resultado2: text.target.value }))
                                                        if (error.resultado2 && delete error.resultado2);
                                                    }
                                                }}
                                            />

                                            {(error.resultado2) &&
                                                <strong className="text-danger">{error.resultado2[0]}</strong>
                                            }
                                        </div>
                                    </div>
                                    </>
                                }

                            {(campaign.ganhador2) &&
                                <>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">2° prêmio</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar src={rootUrl + 'img/rifa/' + campaign.cover.img + '?w=100&h=100&s=' + campaign.id} />
                                    }
                                    title={<h6 className="fw-bold m-0 bs-color-b">{campaign.product2}</h6>}
                                    subheader={
                                        <>
                                        {(campaign.federal === 1 && campaign.concurso) &&
                                            <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{campaign.concurso}</span></span>
                                        }
                                        </>
                                    } 
                                />
                                <CardHeader 
                                    avatar={
                                        <Avatar className="bg-success" sizes="large">
                                            <FaCheck />
                                        </Avatar>
                                    }
                                    title={<h3 className="fw-semibold m-0 bs-color-b">{campaign.extracao2}</h3>}
                                    subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                />
                                
                                <hr className="hr-muted m-0"/>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaUser />
                                        </Avatar>
                                    }
                                    title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={campaign.ganhador2.name} />}</h6>}
                                    subheader={
                                        <>
                                        <div className="d-flex justify-content-between">
                                            <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone2: state.telefone2 ? false : true })}>
                                                {(state.telefone2) ? campaign.ganhador2.telefone : <> {campaign.ganhador2.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                            </span>
                                            
                                            <span className="me-2">
                                                <a href={'http://wa.me/55'+campaign.ganhador2.telefone} target="_blank" rel="noopener noreferrer">
                                                    <IoLogoWhatsapp color="#24d366" size={30}/>
                                                </a>
                                            </span>
                                        </div>

                                        
                                        <span onClick={() => handlePage('shopping', campaign.ganhador2.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                        </>
                                    } 
                                />
                                <hr className="hr-muted m-0"/>
                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                <CardHeader
                                    onClick={() => _detail(campaign.ganhador2_transaction.id, campaign.ganhador2.id)}
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaLaugh />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador2_transaction.transaction_amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador2_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(campaign.ganhador2_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.ganhador2_transaction.updated_at))}</span>
                                        {campaign.ganhador2_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                        </>
                                    }
                                />

                                {campaign.ganhador2_transaction_total.shopping > 1 &&
                                <>

                                <hr className="hr-muted m-0"/>
                                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                <CardHeader
                                    className="pointer"
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaPiggyBank />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador2_transaction_total.amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador2_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color">Compras: {campaign.ganhador2_transaction_total.shopping}</span>
                                        </>
                                    }
                                />
                                </>
                                }

                                </>
                            }
                            </div>
                            {(!campaign.ganhador2) &&
                                <div className="d-flex mt-3">
                                    <button onClick={() => dispatch(second(campaign))} type="button" className="btn btn-success rounded-0">
                                        Sortear
                                    </button>
                                </div>
                            }
                        </div>
                    }

                    {(campaign.product3) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">
                                {(!campaign.ganhador3) &&
                                    <>
                                    <div className="col-md-12">
                                        <label className="label-custom mb-4 bs-color-b">3° prêmio</label>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="label-custom bs-color-b">Resultado {campaign.federal === 1 && 'Loteria Federal'}</label>
                                            <TextField
                                                error={(error.resultado3) && true}
                                                value={campaign.resultado3 || ''}
                                                placeholder="ex: 035154"
                                                type="tel"
                                                InputProps={{
                                                    inputComponent: TextMaskCustom,
                                                    onChange: text => {
                                                        dispatch(change({ resultado3: text.target.value }))
                                                        if (error.resultado3 && delete error.resultado3);
                                                    }
                                                }}
                                            />

                                            {(error.resultado3) &&
                                                <strong className="text-danger">{error.resultado3[0]}</strong>
                                            }
                                        </div>
                                    </div>
                                    </>
                                }

                                {(campaign.ganhador3) &&
                                    <>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">3° prêmio</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + campaign.cover.img + '?w=100&h=100&s=' + campaign.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{campaign.product3}</h6>}
                                        subheader={
                                            <>
                                            {(campaign.federal === 1 && campaign.concurso) &&
                                                <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{campaign.concurso}</span></span>
                                            }
                                            </>
                                        } 
                                    />
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="bg-success" sizes="large">
                                                <FaCheck />
                                            </Avatar>
                                        }
                                        title={<h3 className="fw-semibold m-0 bs-color-b">{campaign.extracao3}</h3>}
                                        subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={campaign.ganhador3.name} />}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone3: state.telefone3 ? false : true })}>
                                                        {(state.telefone3) ? campaign.ganhador3.telefone : <> {campaign.ganhador3.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+campaign.ganhador3.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>

                                                <span onClick={() => handlePage('shopping', campaign.ganhador3.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                    <CardHeader
                                        onClick={() => _detail(campaign.ganhador3_transaction.id, campaign.ganhador3.id)}
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaLaugh />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador3_transaction.transaction_amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador3_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(campaign.ganhador3_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.ganhador3_transaction.updated_at))}</span>
                                            {campaign.ganhador3_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                            </>
                                        }
                                    />

                                    {campaign.ganhador3_transaction_total.shopping > 1 &&
                                    <>
    
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador3_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador3_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {campaign.ganhador3_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
                                    </>
                                    }
    
                                    </>
                                }
                            </div>
                            {(!campaign.ganhador3) &&
                                <div className="d-flex mt-3">
                                    <button onClick={() => dispatch(third(campaign))} type="button" className="btn btn-success rounded-0">
                                        Sortear
                                    </button>
                                </div>
                            }
                        </div>
                    }

                    {(campaign.product4) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">

                                {(!campaign.ganhador4) &&
                                    <>
                                    <div className="col-md-12">
                                        <label className="label-custom mb-4">4° prêmio</label>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="label-custom bs-color-b">Resultado {campaign.federal === 1 && 'Loteria Federal'}</label>
                                            <TextField
                                                error={(error.resultado4) && true}
                                                value={campaign.resultado4 || ''}
                                                placeholder="ex: 035154"
                                                type="tel"
                                                InputProps={{
                                                    inputComponent: TextMaskCustom,
                                                    onChange: text => {
                                                        dispatch(change({ resultado4: text.target.value }))
                                                        if (error.resultado4 && delete error.resultado4);
                                                    }
                                                }}
                                            />

                                            {(error.resultado4) &&
                                                <strong className="text-danger">{error.resultado4[0]}</strong>
                                            }
                                        </div>
                                    </div>
                                    </>
                                }

                                {(campaign.ganhador4) &&
                                    <>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">4° prêmio</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + campaign.cover.img + '?w=100&h=100&s=' + campaign.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{campaign.product4}</h6>}
                                        subheader={
                                            <>
                                            {(campaign.federal === 1 && campaign.concurso) &&
                                                <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{campaign.concurso}</span></span>
                                            }
                                            </>
                                        } 
                                    />
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="bg-success" sizes="large">
                                                <FaCheck />
                                            </Avatar>
                                        }
                                        title={<h3 className="fw-semibold m-0 bs-color-b">{campaign.extracao4}</h3>}
                                        subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={campaign.ganhador4.name} />}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone4: state.telefone4 ? false : true })}>
                                                        {(state.telefone4) ? campaign.ganhador4.telefone : <> {campaign.ganhador4.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+campaign.ganhador4.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>

                                                <span onClick={() => handlePage('shopping', campaign.ganhador4.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                    <CardHeader
                                        onClick={() => _detail(campaign.ganhador4_transaction.id, campaign.ganhador4.id)}
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaLaugh />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador4_transaction.transaction_amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador4_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(campaign.ganhador4_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.ganhador4_transaction.updated_at))}</span>
                                            {campaign.ganhador4_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                            </>
                                        }
                                    />

                                    {campaign.ganhador4_transaction_total.shopping > 1 &&
                                    <>
    
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador4_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador4_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {campaign.ganhador4_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
                                    </>
                                    }
    
                                    </>
                                }
                            </div>
                            {(!campaign.ganhador4) &&
                                <div className="d-flex mt-3">
                                    <button onClick={() => dispatch(fourth(campaign))} type="button" className="btn btn-success rounded-0">
                                        Sortear
                                    </button>
                                </div>
                            }
                        </div>
                    }

                    {(campaign.product5) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">

                                {(!campaign.ganhador5) &&
                                    <>
                                    <div className="col-md-12">
                                        <label className="label-custom mb-4 bs-color-b">5° prêmio</label>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="label-custom bs-color-b">Resultado {campaign.federal === 1 && 'Loteria Federal'}</label>
                                            <TextField
                                                error={(error.resultado5) && true}
                                                value={campaign.resultado5 || ''}
                                                placeholder="ex: 035154"
                                                type="tel"
                                                InputProps={{
                                                    inputComponent: TextMaskCustom,
                                                    onChange: text => {
                                                        dispatch(change({ resultado5: text.target.value }))
                                                        if (error.resultado5 && delete error.resultado5);
                                                    }
                                                }}
                                            />

                                            {(error.resultado5) &&
                                                <strong className="text-danger">{error.resultado5[0]}</strong>
                                            }
                                        </div>
                                    </div>
                                    </>
                                }

                                {(campaign.ganhador5) &&
                                    <>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">5° prêmio</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + campaign.cover.img + '?w=100&h=100&s=' + campaign.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{campaign.product5}</h6>}
                                        subheader={
                                            <>
                                            {(campaign.federal === 1 && campaign.concurso) &&
                                                <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{campaign.concurso}</span></span>
                                            }
                                            </>
                                        } 
                                    />
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="bg-success" sizes="large">
                                                <FaCheck />
                                            </Avatar>
                                        }
                                        title={<h3 className="fw-semibold m-0 bs-color-b">{campaign.extracao5}</h3>}
                                        subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={campaign.ganhador5.name} />}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone5: state.telefone5 ? false : true })}>
                                                        {(state.telefone5) ? campaign.ganhador5.telefone : <> {campaign.ganhador5.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+campaign.ganhador5.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>

                                                <span onClick={() => handlePage('shopping', campaign.ganhador5.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                    <CardHeader
                                        onClick={() => _detail(campaign.ganhador5_transaction.id, campaign.ganhador5.id)}
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaLaugh />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador5_transaction.transaction_amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador5_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(campaign.ganhador5_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(campaign.ganhador5_transaction.updated_at))}</span>
                                            {campaign.ganhador5_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                            </>
                                        }
                                    />

                                    {campaign.ganhador5_transaction_total.shopping > 1 &&
                                    <>
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador5_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador5_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {campaign.ganhador5_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
                                    </>
                                    }
    
                                    </>
                                }
                            </div>
                            {(!campaign.ganhador5) &&
                                <div className="d-flex mt-3">
                                    <button onClick={() => dispatch(fifth(campaign))} type="button" className="btn btn-success rounded-0">
                                        Sortear
                                    </button>
                                </div>
                            }
                        </div>
                    }
					
					{(campaign.product_mais) &&
						<div className="card card-body mt-3 bs-bg">
							<div className="row">
								
                                {(!campaign.ganhador_mais) &&
                                    <>
                                    <div className="col-md-12">
                                        <label className="label-custom mb-4 bs-color-b">Prêmio para quem comprar mais cotas</label>
                                    </div>
                                    </>
                                }

								{(campaign.ganhador_mais) &&
									<>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Prêmio para quem comprar mais cotas</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + campaign.cover.img + '?w=100&h=100&s=' + campaign.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{campaign.product_mais}</h6>}
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={campaign.ganhador_mais.name} />}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone7: state.telefone7 ? false : true })}>
                                                        {(state.telefone7) ? campaign.ganhador_mais.telefone : <> {campaign.ganhador_mais.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+campaign.ganhador_mais.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>
                                                
                                                <span onClick={() => handlePage('shopping', campaign.ganhador_mais.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(campaign.ganhador_mais_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(campaign.ganhador_mais_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {campaign.ganhador_mais_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
    
                                    </>
								}
							</div>
							{(!campaign.ganhador_mais) &&
								<div className="d-flex mt-3">
									<button onClick={() => dispatch(plus(campaign))} type="button" className="btn btn-success rounded-0">
										Sortear
									</button>
								</div>
							}
						</div>
					}
                </>
            }
            </div>
        </>
    )
}